"use client";

import { useRef } from "react";
import type { ArticlesData } from "./interface";
import styles from './Articles.module.scss';

// Helpers
import classnames from "classnames";
import DOMPurify from "@/app/[lang]/utils/dompurify";

// Assets
import ArrowIcon from "../ui/ArrowIcon";

// Components
import Button from "../ui/Button";
import Article from "../Article/Article";

import SnapCarousel from "../ui/SnapCarousel";
import type { SnapCarouselHandle } from "../ui/SnapCarousel";
import {getSafeHeading} from "@/app/[lang]/utils/api-helpers";

export const Articles = ({ data }: { data: ArticlesData }) => {
  const carouselRef = useRef<SnapCarouselHandle>(null);
  const TitleTag = getSafeHeading(data?.headingLevel, "h3");

  return (
    <section className={ classnames( styles.wrapper, 'bg-white text-dark-blue' ) }>
      <div className={ classnames( 'container', styles.mask )}>

        <div className={ styles.header }>
          <div className={ styles.headerText }>
            <TitleTag className={ styles.title }>{ data.headingTitle }</TitleTag>
            <div className={ styles.description } dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.headingDescription) }} />
          </div>

          {!data.button.hidden ?
              <div className={styles.headerButton}>
                <Button attributes={data.button}/>
              </div> : null
          }
        </div>

        <div className={ styles.sliderOffset }> 
          <div className={ styles.sliderWrapper }>
            <SnapCarousel
              ref={ carouselRef }
              scrollerClassName={ styles.scroller }
              slideClassName={ styles.articleSlide }
            >
              {data.articles.data.map((article) => (
                <Article key={article.id} article={article} />
              ))}
            </SnapCarousel>
          </div>

          <div className={ styles.sliderArrows }>
            <ArrowIcon
              color="black"
              direction="left"
              onClick={() => carouselRef.current?.prev()}
            />

            <ArrowIcon
              color="black"
              direction="right"
              onClick={() => carouselRef.current?.next()}
            />
          </div>
        </div>

        <div className={ styles.mobileMoreButtonWrapper }>
          <Button attributes={data.button} />
        </div>
      </div>
    </section>
  );
}
